import { computed, provide } from 'vue';

import { ProvidedHasSalesforceFeed } from '@/injectionKeys/account_drawer';
import {
  useFeedsStore,
  useIndividualRecordStore,
  useSourcesStore,
} from '@/stores';

export function useProvideHasSalesforceFeed() {
  const individualRecordStore = useIndividualRecordStore();
  const sourcesStore = useSourcesStore();
  const feedsStore = useFeedsStore();

  const ownSource = computed(() =>
    individualRecordStore.sourceId
      ? (sourcesStore.getSourceById(individualRecordStore.sourceId) ?? null)
      : null,
  );

  const hasSalesforceFeed = computed(() => {
    const feed = ownSource.value?.feed_id
      ? feedsStore.getFeedById(ownSource.value.feed_id)
      : null;
    return feed?.integration?.type === 'salesforce';
  });

  provide(ProvidedHasSalesforceFeed, hasSalesforceFeed);
}
